var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full realative p-5"},[_c('div',{},[_c('PhoneArea',{staticClass:"full mx-2",attrs:{"maxWidth":414}},[_c('ThankYouCanvas',[_c('DemoLayoutSwat')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }